import { ObservatoryData } from "./data/datamodel";
export * as clarityValues from "./cloudwatcher_values.json";

export const apiURL = "https://ramotswe.globaljetwatch.net/";
export const forecastWidgetURL = (locationCode) =>
  `https://www.yr.no/en/content/${locationCode}/meteogram.svg`;

/**
 * Object containing all Observatory Metadata
 */
export const observatoryMetadata = {
  CL: {
    Name: "Chile",
    TZInfo: "America/Santiago", // luxon compatible (IANA) time zone
    yrnoCode: "2-3872594",
    endpoints: {
      allSky: true,
      frontOfDome: true,
      musca: true,
      cloudwatcher: true,
      cumulus: true,
      vrm: true,
    },
  },
  OX: {
    Name: "Oxford",
    TZInfo: "Europe/London",
    yrnoCode: "2-2640729",
    endpoints: {
      allSky: true,
      frontOfDome: false,
      musca: false,
      cloudwatcher: true,
      cumulus: true,
      vrm: false,
    },
  },
  SA: {
    Name: "South Africa",
    TZInfo: "Africa/Johannesburg",
    yrnoCode: "2-3369157",
    endpoints: {
      allSky: true,
      frontOfDome: true,
      musca: true,
      cloudwatcher: true,
      cumulus: true,
      vrm: true,
    },
  },
  IN: {
    Name: "India",
    TZInfo: "Asia/Kolkata",
    yrnoCode: "2-1272473",
    endpoints: {
      allSky: true,
      frontOfDome: true,
      musca: true,
      cloudwatcher: true,
      cumulus: true,
      vrm: true,
    },
  },
  WA: {
    Name: "Western Australia",
    TZInfo: "Australia/Perth",
    yrnoCode: "2-2063523",
    endpoints: {
      allSky: false,
      frontOfDome: false,
      musca: false,
      cloudwatcher: false,
      cumulus: false,
      vrm: false,
    },
  },
  OZ: {
    Name: "Australia",
    TZInfo: "Australia/Sydney",
    yrnoCode: "2-8299775",
    endpoints: {
      allSky: true,
      frontOfDome: true,
      musca: true,
      cloudwatcher: true,
      cumulus: true,
      vrm: false,
    },
  },
  NM: {
    Name: "New Mexico",
    TZInfo: "America/Boise",
    yrnoCode: "2-5478345",
    endpoints: {
      allSky: true,
      frontOfDome: true,
      musca: true,
      cloudwatcher: true,
      cumulus: true,
      vrm: false,
    },
  },
};

/**
 * Object to store API data
 *
 * Access specific data with OBS.dataChunkName.dataPointName
 * Update a data chunk with OBS.dataChunkName.update()
 *
 * For chunk names:
 * panel data (single most recent data points) is *Snapshot
 * graph data (historic data points) is *History
 */
export const observatoryData = {
  CL: new ObservatoryData("CL"),
  OX: new ObservatoryData("OX"),
  SA: new ObservatoryData("SA"),
  IN: new ObservatoryData("IN"),
  WA: new ObservatoryData("WA"),
  OZ: new ObservatoryData("OZ"),
  NM: new ObservatoryData("NM"),
};

// initial values = defaults
export const currentState = {
  currentObservatory: "IN",
  currentPanel: 0,
  refreshIntervalID: null,
};

// Minimum time between user-initiated data refreshes (seconds)
export const minimumRefreshTime = 5;

export let carousel = null;

export const allGraphs = Array();

export const internalCurrentState = {
  currentPanel: "Telemetry",
  refreshIntervalID: null,
};
